import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import CheckIcon from '@mui/icons-material/Check';

import {setWizardSelectedValues} from "../../../../../actions/wizardFunctions";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import FeatureThumbnail from "../../../../visComponents/featureThumbnail";
import {featureGroupInterface} from "../../../../../interfaces/featureInterface";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import WithClickCount from "../../../hocs/withClickCount";
import {navFeatureCLick} from "../../lookFunctions";
import {getCurrentLayout} from "../../../../appLayout";
import {getFeatureGroupFromWizardGroup} from "./lookWizardFunctions";
import {checkIfLookFeaturesReceived} from "../../../../../api/look-api";
import {loaderDisable, loaderEnable} from "../../../../ui/loaderView";
import {getWizardFeatureAsync} from "./wizardFunctionsCommon";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import {featureCanChangeShowerSize, searchForSameNameWallsBeforeFeatureApply} from "../../../bathroomFunctions";
import Config from "../../../../../config";


const LookWizardSectionGroup = (props) => {

  const {wizardGroup, wizardActiveStep, setWizardSelectedValues, wizardSelectedValues, featureGroup, updateCanvasCount,
    lookViewType} = props;
  const {customImageUrl, uploadedImageUrl} = wizardGroup;

  const isActive = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].wizardGroup
    && wizardSelectedValues[wizardActiveStep].wizardGroup.id === wizardGroup.id;

  const wizardItemClick = async (maxClickCountReached) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardParent + Analytics.getStringForAnalytics(wizardGroup.groupName));

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);

    if (featureGroup && !featureGroup.allFeaturesReceived) {
      loaderEnable();
      await checkIfLookFeaturesReceived(featureGroup);
      loaderDisable();
    }

    if (featureGroup && featureGroup.activeFeature) {
      if (featureGroup.partId === "vanity_sink" && wizardGroup.productCartTitle
        && wizardGroup.productCartTitle.includes("edestal") && featureGroup.getParent().vanity_type) {
        const layout = getCurrentLayout();
        const navItems = layout.designNavigationItems({part: featureGroup});
        const nextPedestal = navItems.find(navItem => Array.isArray(navItem.part.metaData["MountType"]) && navItem.part.metaData["MountType"].includes("ST"));
        if (nextPedestal) {
          navFeatureCLick(nextPedestal.part);
        } else {
          navFeatureCLick(featureGroup.activeFeature);
        }
      }
      navFeatureCLick(featureGroup.activeFeature);
      updateCanvasCount();
    }

    setWizardSelectedValues({
      [wizardActiveStep]: {
        wizardGroup,
        partId: featureGroup ? featureGroup.partId : ""
      }
    });
    if (Config.isDevMode()) {
      console.log("wizardGroupwizardGroup", wizardGroup);
    }
    if (wizardGroup.clickOnLogic && wizardGroup.clickOnLogic.enabled && wizardGroup.clickOnLogic.feature
      && wizardGroup.clickOnLogic.groupName) {
      const featureFound = await getWizardFeatureAsync(wizardGroup.clickOnLogic.feature, wizardGroup.clickOnLogic.groupName);
      if (Config.isDevMode()) {
        console.log("clickOnLogic featureFound", featureFound);
      }
      if (featureFound) {
        const layout = getCurrentLayout();
        if ((layout.isNewLayout || (layout.visualizerType === "bvScene")) && featureCanChangeShowerSize(featureFound)) {
          loaderEnable();
          await searchForSameNameWallsBeforeFeatureApply(featureFound);
          loaderDisable();
        }
        navFeatureCLick(featureFound);
        updateCanvasCount();
      }
    }
  }

  return (
    <WithClickCount>
      {(maxClickCountReached) => (
        <li className={"lm-feature lm-feature--type-" + lookViewType + (isActive ? " lm-feature--active" : "")}
            onClick={() => wizardItemClick(maxClickCountReached)}>
          <div className="lm-feature__thumbnail">
            {isActive ? (
              <div className="lm-feature__checkmark">
                <CheckIcon fontSize="small"/>
              </div>
            ) : null}
            {customImageUrl || uploadedImageUrl ? (
              <div className="feature-thumbnail" style={{
                background: `url(${customImageUrl || uploadedImageUrl}) center / contain no-repeat`,
              }}/>
            ) : null}
            {!customImageUrl && !uploadedImageUrl && featureGroup && featureGroup.activeFeature ? (
              <FeatureThumbnail feature={featureGroup.activeFeature}
                                dbFeatureId={featureGroup.activeFeature.dbFeature.id}/>
            ) : null}
          </div>
          <div className="lm-feature__content lm-feature__content--no-price">
            <span className="lm-feature__content-name">
              {wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}
            </span>
            {wizardGroup.productCartDescription ? (
              <p className="lm-feature__content-description">{wizardGroup.productCartDescription}</p>
            ) : null}
          </div>
        </li>
      )}
    </WithClickCount>
  )
};

LookWizardSectionGroup.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  featureGroup: PropTypes.shape(featureGroupInterface),
}

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {filterGroups} = store.filterState;

  return {
    wizardActiveStep,
    wizardSelectedValues,
    lookViewType,
    // wizardActiveItem,
    filterGroups,
  };
};

const mapDispatchToProps = {
  setWizardSelectedValues,
  updateCanvasCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionGroup)
